import { ModeleDeBase } from "./ModeleDeBase";

export interface IPilotageCDS {
  si_parametresdepilotage: string;
  si_valeur_texte_court: string;
  si_valeur_texte_long: string;
  si_pilotageid: string;
}

export class Pilotage extends ModeleDeBase {
  nomParametre: string;
  valeurTexteCourt: string;
  valeurTexteLong: string;

  constructor(entity: IPilotageCDS) {
    super(entity.si_pilotageid);

    this.nomParametre = entity.si_parametresdepilotage;
    this.valeurTexteCourt = entity.si_valeur_texte_court;
    this.valeurTexteLong = entity.si_valeur_texte_long;
  }

  serialiser(): IPilotageCDS {
    return {
      si_pilotageid: this.id,
      si_parametresdepilotage: this.nomParametre,
      si_valeur_texte_court: this.valeurTexteCourt,
      si_valeur_texte_long: this.valeurTexteLong,
    };
  }
}
